/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrialOnboardingProgressControllerUpdateMutationRequest, TrialOnboardingProgressControllerUpdateMutationResponse, TrialOnboardingProgressControllerUpdatePathParams, TrialOnboardingProgressControllerUpdate400, TrialOnboardingProgressControllerUpdate401, TrialOnboardingProgressControllerUpdate403, TrialOnboardingProgressControllerUpdate404 } from "../../models/trialOnboardingProgressController/TrialOnboardingProgressControllerUpdate";

function getTrialOnboardingProgressControllerUpdateUrl(progressId: TrialOnboardingProgressControllerUpdatePathParams["progressId"]) {
  const res = { method: 'PATCH', url: `/api/v1/trial-onboarding-progress/${progressId}` as const }  
  return res
}

/**
 * @summary Update trial onboarding progress
 * {@link /api/v1/trial-onboarding-progress/:progressId}
 */
export async function trialOnboardingProgressControllerUpdate(progressId: TrialOnboardingProgressControllerUpdatePathParams["progressId"], data?: TrialOnboardingProgressControllerUpdateMutationRequest, config: Partial<RequestConfig<TrialOnboardingProgressControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TrialOnboardingProgressControllerUpdateMutationResponse, ResponseErrorConfig<TrialOnboardingProgressControllerUpdate400 | TrialOnboardingProgressControllerUpdate401 | TrialOnboardingProgressControllerUpdate403 | TrialOnboardingProgressControllerUpdate404>, TrialOnboardingProgressControllerUpdateMutationRequest>({ method : "PATCH", url : getTrialOnboardingProgressControllerUpdateUrl(progressId).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}